import React from 'react';
import { View, Text } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { ICustomHeaderProps } from 'app/types';

export const CustomHeader: React.FC<ICustomHeaderProps> = ({
    title,
    style,
    className
}) => {
    const insets = useSafeAreaInsets();

    return (
        <View
            className={`pb-6 ${className}`}
            style={{ paddingTop: insets.top + 20, ...style }}
        >
            <Text className="font-heading text-3xl capitalize mt-3">
                {title}
            </Text>
        </View>
    );
};
